/*
 * RESADE rs-fotodialog.js (Kaufseite Runde 3, 27.09.2026; Runde 3c, E-151)
 * Gemeinsame Großansicht für Kundenfotos und Kundenvideo: Bewertungsband (rs-bewertungen, auch Startseite) und
 * Fotostreifen der Kaufbühne (rs-kaufbuehne, Blocktyp fotostreifen). Vorher initFotos in rs-bewertungen.js.
 *
 * 1. Großansicht: Ein Knopf [data-rs-fotodialog-auf] mit aria-controls öffnet das native dialog
 *    [data-rs-fotodialog], optional beim Medium data-rs-fotodialog-start (0 = erstes). Wischen (Einrasten) oder
 *    Pfeile, Pfeiltasten im Dialog (nicht auf dem Video, dort spulen sie), Ansage „Foto n von N“ aus data-zaehler.
 *    Escape, „Schließen“ und ein Klick neben das Fenster schließen; danach steht der Fokus wieder auf dem Knopf.
 *    Videos stehen als <template data-rs-fotodialog-video> im Markup und werden erst beim ersten Öffnen
 *    eingesetzt (kein Laden vorher). Beim Weiterwischen und beim Schließen halten sie an. Trägt der Knopf
 *    data-rs-fotodialog-abspielen (Videokachel des Streifens, E-151), startet das Video der Startfolie gleich
 *    im Klick, also mit Ton; die Bedienleiste zum Anhalten bleibt.
 *    Ohne dialog-Unterstützung bleiben die Knöpfe verborgen, die Bilder stehen ohne Großansicht da.
 *    E-178 (Runde 20, Denny: Galerie-Bild antippen zeigt es groß): window.rsFotodialogEinrichten(dlg) gibt dieselbe
 *    Einrichtung für Dialoge, deren Liste ein anderes Skript füllt und selbst öffnet (Galerie der Kaufbühne,
 *    rs-buybox.js). Optional dlg.rsNachSchliessen(n): bekommt beim Schließen die Nummer des zuletzt gezeigten
 *    Mediums (ab 0) und gibt das Element für den Fokus zurück; ohne Rückruf geht er wie bisher an den Knopf.
 *
 * 2. Fotostreifen [data-rs-fotostreifen]: Pfeile [data-rs-fotostreifen-schritt] blättern um eine Kachel.
 *    Die Videokachel (E-149, stumme Schleife wie live) spielt ihren kurzen Clip nur, solange sie sichtbar ist
 *    und keine Großansicht offen ist, nie bei reduzierter Bewegung (System, auch beim Umschalten während des
 *    Besuchs, oder html.ohne-bewegung). Seit E-151 ohne sichtbare Bedienzeichen: Der Knopf zum Anhalten erscheint
 *    nur bei Tastaturfokus (CSS), das Abspiel-Zeichen nur, wenn der Clip steht (Klasse ist-still am Medium bei
 *    reduzierter Bewegung oder gesperrtem Autostart). Wer anhält, bleibt angehalten.
 *    Ladezeit-Runde 03.10.2026 (C2): Die Kachelbilder stehen im Markup in einem noscript und kommen erst bei
 *    Annäherung (600 px Vorlauf), siehe streifenBilderFrei.
 *
 * Kein Framework, keine Abhängigkeiten. Mehrfach ladbar (Theme-Editor, mehrere Sections).
 */
(function () {
  'use strict';
  if (window.rsFotodialogGeladen) return;
  window.rsFotodialogGeladen = true;

  var bewegungMq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;

  function ruhig() {
    if (document.documentElement.classList.contains('ohne-bewegung')) return true;
    return !!(bewegungMq && bewegungMq.matches);
  }

  // Rückmeldung 02.10.2026 (Ladezeit am Handy): Mit Datensparmodus (Save-Data) startet die Kachel nicht von selbst
  function sparen() {
    var c = navigator.connection;
    return !!(c && c.saveData);
  }

  // Wird ein Knopf mit Fokus gesperrt, setzt der Browser den Fokus auf die Seite zurück (WCAG 2.4.3).
  // Deshalb vorher auf den Ersatz legen.
  function sperren(knopf, gesperrt, ersatz) {
    if (!knopf || knopf.disabled === gesperrt) return;
    if (gesperrt && document.activeElement === knopf && ersatz && typeof ersatz.focus === 'function') {
      ersatz.focus({ preventScroll: true });
    }
    knopf.disabled = gesperrt;
  }

  // Zwei Pfeile: erst den frei werdenden entsperren, dann den anderen sperren; Ersatz ist der freie Pfeil, sonst rueckfall
  function paarSperren(a, aZu, b, bZu, rueckfall) {
    if (a && !aZu) sperren(a, false);
    if (b && !bZu) sperren(b, false);
    if (a && aZu) sperren(a, true, b && !bZu ? b : rueckfall);
    if (b && bZu) sperren(b, true, a && !aZu ? a : rueckfall);
  }

  /* ---------- 1. Großansicht ---------- */

  // Ladezeit 01.10.2026: Solange eine Galerie-Großansicht offen ist, trägt html die Klasse rs-galerie-offen (am Handy
  // scrollt die Seite darunter dann nicht, rs-fotodialog.css). Vorher hing das an html:has(...[open]), das jede
  // DOM-Einfügung das ganze Dokument neu berechnen ließ. Abgleich statt Zählen: offen ist, was [open] trägt.
  // Mobil-Check 08.10.2026 (P3-6): ebenso das Fenster des Fotostreifens („Fotos aus echten Küchen“, rs-fotodialog--hoch);
  // dort ließ sich die Seite dahinter beim Wischen verschieben. Freigabe wie bei der Galerie über das close-Ereignis
  // (Escape, „Schließen“, Klick neben das Fenster).
  function galerieAbgleichen() {
    var offen = !!document.querySelector('.rs-fotodialog--galerie[open], .rs-fotodialog--hoch[open]');
    var html = document.documentElement;
    if (html.classList.contains('rs-galerie-offen') !== offen) html.classList.toggle('rs-galerie-offen', offen);
  }

  // Runde 24: dasselbe für das Produktblatt des Bambus-Sets (data-rs-blatt, rs-bambus-blatt.liquid): html.rs-blatt-offen,
  // am Handy steht die Seite darunter still (rs-kaufbuehne.css)
  function blattAbgleichen() {
    var offen = !!document.querySelector('.rs-fotodialog[data-rs-blatt][open]');
    var html = document.documentElement;
    if (html.classList.contains('rs-blatt-offen') !== offen) html.classList.toggle('rs-blatt-offen', offen);
  }

  function dialogEinrichten(dlg) {
    if (dlg.rsFotodialog) return dlg.rsFotodialog;
    var spur = dlg.querySelector('[data-rs-fotodialog-spur]');
    var bilder = spur ? spur.children : [];
    var zaehler = dlg.querySelector('[data-rs-fotodialog-zaehler]');
    var zurueck = dlg.querySelector('[data-rs-fotodialog-schritt="-1"]');
    var weiter = dlg.querySelector('[data-rs-fotodialog-schritt="1"]');
    var zu = dlg.querySelector('[data-rs-fotodialog-zu]');
    var muster = dlg.getAttribute('data-zaehler') || '{n} / {gesamt}';
    var ausloeser = null;
    var videosDa = false;
    // E-178: zuletzt gezeigtes Medium; nach dem Schließen liefert index() 0, weil die Spur keine Breite mehr hat
    var zuletzt = 0;

    function index() {
      if (!spur || !spur.clientWidth) return 0;
      return Math.max(0, Math.min(bilder.length - 1, Math.round(spur.scrollLeft / spur.clientWidth)));
    }
    function videosAnhalten(ausser) {
      var v = dlg.querySelectorAll('video');
      for (var i = 0; i < v.length; i++) if (v[i] !== ausser && !v[i].paused) v[i].pause();
    }
    function zeichnen() {
      var n = index();
      if (dlg.open) zuletzt = n;
      var text = muster.replace('{n}', String(n + 1)).replace('{gesamt}', String(bilder.length));
      if (zaehler && zaehler.textContent !== text) zaehler.textContent = text;
      paarSperren(zurueck, n === 0, weiter, n >= bilder.length - 1, zu);
      var aktiv = bilder[n] ? bilder[n].querySelector('video') : null;
      videosAnhalten(aktiv);
    }
    function gehe(n, sofort) {
      if (!spur) return;
      var ziel = Math.max(0, Math.min(bilder.length - 1, n));
      spur.scrollTo({ left: ziel * spur.clientWidth, behavior: sofort || ruhig() ? 'auto' : 'smooth' });
    }
    function videosEinsetzen() {
      if (videosDa) return;
      videosDa = true;
      var vorlagen = dlg.querySelectorAll('template[data-rs-fotodialog-video]');
      for (var i = 0; i < vorlagen.length; i++) {
        vorlagen[i].parentNode.insertBefore(vorlagen[i].content.cloneNode(true), vorlagen[i]);
      }
    }
    function oeffnen(knopf, start, abspielen) {
      ausloeser = knopf || null;
      videosEinsetzen();
      dlg.showModal();
      galerieAbgleichen();
      blattAbgleichen();
      gehe(start || 0, true);
      zeichnen();
      if (abspielen) {
        // Noch im Klick: Der Browser erlaubt Ton nur so. Scheitert es, steht die Bedienleiste bereit.
        var v = bilder[start || 0] ? bilder[start || 0].querySelector('video') : null;
        if (v) {
          var p = v.play();
          if (p && typeof p.catch === 'function') p.catch(function () {});
        }
      }
    }

    dlg.addEventListener('close', function () {
      galerieAbgleichen();
      blattAbgleichen();
      videosAnhalten(null);
      // E-178: Wer die Liste füllt, kann das Ziel des Fokus bestimmen (etwa den Knopf des zuletzt gezeigten Bilds)
      var ziel = null;
      if (typeof dlg.rsNachSchliessen === 'function') {
        try {
          ziel = dlg.rsNachSchliessen(zuletzt);
        } catch (e) {
          ziel = null;
        }
      }
      var f = ziel || ausloeser;
      if (f && typeof f.focus === 'function') f.focus();
    });
    // Nur ein Klick wirklich neben das Fenster schließt, nicht einer in dessen Innenabstand
    dlg.addEventListener('click', function (e) {
      if (e.target !== dlg) return;
      var r = dlg.getBoundingClientRect();
      if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) dlg.close();
    });
    if (zu) zu.addEventListener('click', function () { dlg.close(); });
    if (zurueck) zurueck.addEventListener('click', function () { gehe(index() - 1); });
    if (weiter) weiter.addEventListener('click', function () { gehe(index() + 1); });
    dlg.addEventListener('keydown', function (e) {
      // Auf dem Video gehören die Pfeiltasten dem Player (Spulen, Lautstärke)
      if (e.target && e.target.tagName === 'VIDEO') return;
      if (e.key === 'ArrowLeft') { e.preventDefault(); gehe(index() - 1); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); gehe(index() + 1); }
    });
    if (spur) {
      var wartet = false;
      spur.addEventListener('scroll', function () {
        if (wartet) return;
        wartet = true;
        requestAnimationFrame(function () { wartet = false; zeichnen(); });
      }, { passive: true });
    }
    dlg.rsFotodialog = { oeffnen: oeffnen };
    return dlg.rsFotodialog;
  }

  function knoepfeEinrichten(wurzel) {
    var knoepfe = wurzel.querySelectorAll('[data-rs-fotodialog-auf]');
    for (var i = 0; i < knoepfe.length; i++) {
      (function (knopf) {
        if (knopf.rsFotodialogAn) return;
        knopf.rsFotodialogAn = true;
        // Kopien im Laufband der Bewertungen sind inert und aria-hidden
        if (knopf.closest('[inert], [aria-hidden="true"]')) return;
        var dlg = document.getElementById(knopf.getAttribute('aria-controls'));
        if (!dlg || typeof dlg.showModal !== 'function') {
          knopf.hidden = true;
          return;
        }
        var d = dialogEinrichten(dlg);
        // Im Streifen trägt der Knopf den Alt-Text schon im Namen; das Bild daneben nicht zweimal vorlesen
        if (knopf.closest('[data-rs-fotostreifen]')) {
          var bild = knopf.parentNode ? knopf.parentNode.querySelector('img') : null;
          if (bild) bild.setAttribute('aria-hidden', 'true');
        }
        knopf.addEventListener('click', function () {
          d.oeffnen(knopf, parseInt(knopf.getAttribute('data-rs-fotodialog-start') || '0', 10) || 0,
            knopf.hasAttribute('data-rs-fotodialog-abspielen'));
        });
      })(knoepfe[i]);
    }
  }

  /* ---------- 2. Fotostreifen ---------- */

  // Ladezeit-Runde 03.10.2026 (C2): Die Kacheln tragen ihr Bild in <noscript data-rs-streifen-bild>
  // (rs-kaufbuehne.liquid). Chrome lud sie trotz loading=lazy schon beim Start, rund 82 KB vor dem ersten Bild, weil
  // seine Lazy-Grenze weit unter das Fenster reicht. Eingesetzt wird bei Annäherung: eigener IntersectionObserver auf
  // der Liste mit 600 px Vorlauf (der Beobachter weiter unten gilt nur der Videokachel), ohne IntersectionObserver
  // sofort. innerHTML liest den Inhalt als Text (Skripte an) und als Elemente (Section über DOMParser eingesetzt).
  // Ist die Großansicht bereit, trägt der Knopf der Kachel den Alt-Text im Namen; das Bild bleibt dann für
  // Screenreader stumm wie bei knoepfeEinrichten. width und height stehen am img, die Kachel hält ihr Format.
  function streifenBilderFrei(liste) {
    var n = liste.querySelectorAll('noscript[data-rs-streifen-bild]');
    for (var i = 0; i < n.length; i++) {
      var medium = n[i].parentNode;
      var vorlage = document.createElement('template');
      vorlage.innerHTML = n[i].innerHTML;
      var bild = vorlage.content.querySelector('img');
      var knopf = medium && medium.querySelector ? medium.querySelector('[data-rs-fotodialog-auf]') : null;
      if (bild && knopf && knopf.rsFotodialogAn && !knopf.hidden) bild.setAttribute('aria-hidden', 'true');
      medium.replaceChild(vorlage.content, n[i]);
    }
  }

  function streifenBilderBeobachten(liste) {
    if (!liste.querySelector('noscript[data-rs-streifen-bild]')) return null;
    if (!('IntersectionObserver' in window)) {
      streifenBilderFrei(liste);
      return null;
    }
    var nah = new IntersectionObserver(function (eintraege) {
      for (var i = 0; i < eintraege.length; i++) {
        if (eintraege[i].isIntersecting) {
          nah.disconnect();
          streifenBilderFrei(liste);
          return;
        }
      }
    }, { rootMargin: '600px 0px' });
    nah.observe(liste);
    return nah;
  }

  function streifenEinrichten(wurzel) {
    var streifen = wurzel.querySelectorAll('[data-rs-fotostreifen]');
    for (var i = 0; i < streifen.length; i++) {
      (function (st) {
        if (st.rsFotostreifenAn) return;
        st.rsFotostreifenAn = true;
        // Alles, was am Fenster oder Dokument hängt, löst sich beim Neuladen der Section im Theme-Editor
        var ende = typeof AbortController === 'function' ? new AbortController() : null;
        var mit = ende ? { signal: ende.signal } : undefined;
        var beobachter = null;
        var bilderNah = null;
        document.addEventListener('shopify:section:unload', function (e) {
          if (!e.target || !e.target.contains(st)) return;
          if (ende) ende.abort();
          if (beobachter) beobachter.disconnect();
          if (bilderNah) bilderNah.disconnect();
        }, mit);

        var liste = st.querySelector('[data-rs-fotostreifen-liste]');
        if (liste) {
          bilderNah = streifenBilderBeobachten(liste);
          var schritte = st.querySelectorAll('[data-rs-fotostreifen-schritt]');
          var knopfZurueck = st.querySelector('[data-rs-fotostreifen-schritt="-1"]');
          var knopfWeiter = st.querySelector('[data-rs-fotostreifen-schritt="1"]');
          for (var j = 0; j < schritte.length; j++) {
            (function (b) {
              b.addEventListener('click', function () {
                var kachel = liste.firstElementChild;
                var breite = kachel ? kachel.getBoundingClientRect().width + parseFloat(getComputedStyle(liste).columnGap || 0) : liste.clientWidth;
                liste.scrollBy({ left: breite * parseInt(b.getAttribute('data-rs-fotostreifen-schritt'), 10), behavior: ruhig() ? 'auto' : 'smooth' });
              });
            })(schritte[j]);
          }
          var randZeichnen = function () {
            var max = liste.scrollWidth - liste.clientWidth;
            var amAnfang = liste.scrollLeft <= 1;
            var amEnde = liste.scrollLeft >= max - 1;
            // Fokus am Ende auf den anderen Pfeil, sonst auf die Liste (BF-5)
            paarSperren(knopfZurueck, amAnfang, knopfWeiter, amEnde, liste);
          };
          liste.addEventListener('scroll', function () { requestAnimationFrame(randZeichnen); }, { passive: true });
          window.addEventListener('resize', randZeichnen, mit);
          randZeichnen();
        }

        var video = st.querySelector('video[data-rs-fotostreifen-clip]');
        var pause = st.querySelector('[data-rs-fotostreifen-pause]');
        if (!video) return;
        var medium = video.parentNode;
        // Rückmeldung 02.10.2026 (Ladezeit am Handy): Standbild aus data-rs-poster erst bei Annäherung (600 px) oder
        // vor dem ersten Abspielen; ein poster im HTML holte der Browser vor dem großen Galeriebild
        function standbild() {
          var url = video.getAttribute('data-rs-poster');
          if (url && !video.getAttribute('poster')) video.setAttribute('poster', url);
        }
        if ('IntersectionObserver' in window) {
          var nah = new IntersectionObserver(function (eintraege) {
            for (var n = 0; n < eintraege.length; n++) {
              if (eintraege[n].isIntersecting) {
                standbild();
                nah.disconnect();
                return;
              }
            }
          }, { rootMargin: '600px 0px' });
          nah.observe(video);
        } else {
          standbild();
        }
        var angehalten = false;
        var sichtbar = false;
        var dialogOffen = false;
        function knopfZeichnen() {
          if (!pause) return;
          // Festes Label „anhalten“; gedrückt heißt: vom Besucher angehalten (JS-8)
          pause.setAttribute('aria-pressed', angehalten ? 'true' : 'false');
          pause.classList.toggle('ist-angehalten', angehalten);
        }
        function still(ja) {
          if (medium) medium.classList.toggle('ist-still', ja);
        }
        function spielen() {
          standbild();
          if (ruhig() || sparen()) { still(true); return; }
          if (angehalten || !sichtbar || dialogOffen || document.hidden) return;
          var p = video.play();
          if (p && typeof p.catch === 'function') {
            p.catch(function (fehler) {
              // Gesperrter Autostart (etwa Stromsparmodus): Kachel als Video kenntlich machen
              if (fehler && fehler.name === 'NotAllowedError') still(true);
            });
          }
        }
        video.addEventListener('play', function () { still(false); });
        if (pause) {
          pause.hidden = ruhig() || sparen();
          pause.addEventListener('click', function () {
            if (angehalten) {
              angehalten = false;
              sichtbar = true;
              spielen();
            } else {
              angehalten = true;
              video.pause();
            }
            knopfZeichnen();
          });
        }
        // Großansicht dieses Streifens offen: Kachel hält an, danach geht es weiter (JS-5)
        var aufKnopf = st.querySelector('[data-rs-fotodialog-auf]');
        var dlg = aufKnopf ? document.getElementById(aufKnopf.getAttribute('aria-controls')) : null;
        var aufKnoepfe = st.querySelectorAll('[data-rs-fotodialog-auf]');
        for (var k = 0; k < aufKnoepfe.length; k++) {
          aufKnoepfe[k].addEventListener('click', function () {
            dialogOffen = true;
            video.pause();
          });
        }
        if (dlg) {
          dlg.addEventListener('close', function () {
            dialogOffen = false;
            spielen();
          });
        }
        if ('IntersectionObserver' in window) {
          beobachter = new IntersectionObserver(function (eintraege) {
            // Der neueste Eintrag gilt (JS-6)
            sichtbar = eintraege[eintraege.length - 1].isIntersecting;
            if (sichtbar) spielen();
            else video.pause();
          }, { threshold: 0.5 });
          beobachter.observe(video);
        }
        document.addEventListener('visibilitychange', function () {
          if (document.hidden) video.pause();
          else spielen();
        }, mit);
        // Stellt jemand „Bewegung reduzieren“ während des Besuchs um, gilt das sofort (JS-7)
        if (bewegungMq && typeof bewegungMq.addEventListener === 'function') {
          bewegungMq.addEventListener('change', function () {
            if (pause) pause.hidden = ruhig() || sparen();
            if (ruhig() || sparen()) {
              video.pause();
              still(true);
            } else {
              still(false);
              spielen();
            }
          }, mit);
        }
        if (ruhig() || sparen()) still(true);
        knopfZeichnen();
      })(streifen[i]);
    }
  }

  function init(wurzel) {
    var w = wurzel || document;
    knoepfeEinrichten(w);
    streifenEinrichten(w);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  // Verschwindet eine offene Großansicht ohne close-Ereignis (Section im Theme-Editor neu gerendert) oder kommt die
  // Seite aus dem Zurück-Speicher, darf die Scroll-Sperre nicht stehen bleiben (vgl. html.prevent-scroll in CLAUDE.md)
  document.addEventListener('shopify:section:unload', function () {
    setTimeout(galerieAbgleichen, 0);
    setTimeout(blattAbgleichen, 0);
  });
  window.addEventListener('pageshow', galerieAbgleichen);
  window.addEventListener('pageshow', blattAbgleichen);
  // Das Laufband der Bewertungen hängt seine Kopien später an; neue Knöpfe dort sind inert und werden übersprungen
  window.rsFotodialogInit = init;
  // E-178: Einrichtung eines einzelnen Dialogs für die Galerie der Kaufbühne (rs-buybox.js)
  window.rsFotodialogEinrichten = dialogEinrichten;
})();
